<div class="links">
    {{content}}
    <a *ngIf="!isContentToggled && original?.length > limit" (click)="toggleContent()"
        style="color:blue; text-decoration: underline;">Read more</a>
    <a *ngIf="isContentToggled && original?.length > limit" (click)="toggleContent()"
        style="color:blue; text-decoration: underline;">Read less</a>
</div>